import { dataService } from "../services/data.service";
import { pushProfilePhotoToS3 } from "./fileUpload";

async function S3UploadHook(file,path, isPublic) {
    let body = {
        "content_type": file.type,
        "file_path": `${path}${path !== '' ? '/' : ''}${file.name}`,
        "object_acl": isPublic ? "public-read" : "private"
    }
    const data = await dataService.getS3SignUrl(body);
    const url= data.data.url
    if(url){
        // const photoConvertedToBlob = dataURIToBlob(profilePhotoResized);
        const res = await pushProfilePhotoToS3(url, file);
        if(res.status === 200){
            let temp=''
            temp= URL.createObjectURL(file);
            return temp
        }
    }
}

export default S3UploadHook;